import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
import { PouchApp } from "./pouch-app";
const AppContext = createContext(null);
/**
 * Provides PouchApp instance to the component tree.
 */
export const AppProvider = ({ children, app }) => {
    const appInstance = useMemo(() => app ?? new PouchApp(), [app]);
    return _jsx(AppContext.Provider, { value: appInstance, children: children });
};
/**
 * Hook to access the PouchApp instance.
 * Must be used within an AppProvider.
 */
export function useApp() {
    const app = useContext(AppContext);
    if (!app) {
        throw new Error("useApp must be used within an AppProvider");
    }
    return app;
}
